import {Menu, MenuItem} from './index';
import {getParent} from '@mvps-genesis/selector-helpers';
import {hasKeyboardModifier} from '@mvps-genesis/event-helpers';

export default class MenuBar extends Menu {

	static selector = '[role="menubar"]';

	static fromNodeList (nodeList, options) {
		return Array.from(nodeList).map(node => new MenuBar({
			element: node,
			...options
		}));
	};

	constructor (options) {
		super(options);
	}

	init (options) {
		this.validateOptions(options);
		this.setChildMenuItems();
	}

	setChildMenuItems () {
		const menuItems = this._validator.isElementList('menuItems', MenuItem.selector, {container: this.element});
		const childMenuItems = Array.from(menuItems).filter(menuItem => {
			return getParent(menuItem, MenuBar.selector) === this.element && getParent(menuItem, Menu.selector) === null;
		});

		if (!childMenuItems || childMenuItems.length === 0) {
			// eslint-disable-next-line no-console
			console.error(`MenuBar :: unable to find any menuitem children`);
			return false;
		}

		this.childMenuItems = MenuItem.fromNodeList(childMenuItems, {
			parentMenuBar: this,
			parentOptions: {
				breakpoint: this.breakpoint,
				navigateOnDown: this.navigateOnDown,
				navigateOnEnter: this.navigateOnEnter,
				navigateOnSpace: this.navigateOnSpace,
				subMenuFocusDelay: this.subMenuFocusDelay
			}
		});

		return true;
	}

	onLeft (e, target) {
		if (hasKeyboardModifier(e)) {
			return false;
		}
		e.preventDefault();

		this.focusPreviousMenuItem(target && target.parentMenuBarItem ? target.parentMenuBarItem : target);

		return true;
	}

	onRight (e, target) {
		if (hasKeyboardModifier(e)) {
			return false;
		}
		e.preventDefault();

		this.focusNextMenuItem(target && target.parentMenuBarItem ? target.parentMenuBarItem : target);

		return true;
	}

};
